/**
 * Check Icon Component
 * Reusable SVG icon for success/check actions
 */
import React from "react";
import PropTypes from "prop-types";

const CheckIcon = ({
  size = 20,
  color = "currentColor",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M7.629 13.314l-3.3-3.3 1.414-1.415 1.886 1.887 5.328-5.328 1.415 1.414-6.743 6.742z"
        fill={color}
      />
    </svg>
  );
};

CheckIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
};

export default CheckIcon;
